<!-- <div fxShow fxHide.gt-sm class="container-fluid">
<div class="row">
  <div class="col-1"></div>
  <div class="col-auto">
    <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'fr' }}</h3>
  </div>
  <div class="col-auto ">
    <div class="btn-group">
      <mat-button-toggle-group>
        <mat-button-toggle
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          <mat-icon class="material-symbols-outlined">restore</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</div>
<div class="row" [ngSwitch]="view">
  <mwl-calendar-month-view
    *ngSwitchCase="CalendarView.Month"
    [weekStartsOn]="1"
    [locale]="locale"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    [openDayEventsTemplate]="customOpenDayEventsTemplate"
    [cellTemplate]="customCellTemplate">
  </mwl-calendar-month-view>
  <mwl-calendar-day-view
    *ngSwitchCase="CalendarView.Day"
    [locale]="locale"
    [dayStartHour]="6"
    [dayEndHour]="20"
    [hourSegments]="4"
    [hourSegmentHeight]="50"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
    [eventTemplate]="customDayCellTemplate">

  </mwl-calendar-day-view>
</div>
</div> -->

<div class="container-fluid h-100">

    <mat-drawer-container class="h-100" autosize>
        <mat-drawer #drawer mode="side" position="end" class="h-100">

            <!-- <div *ngFor="let int of UnplannedList" class="col text-center border rounded-1 m-1 p-2 ">
      <div>{{int.Code}}</div>
    </div> -->
            <mat-form-field class="w-100">
                <mat-label>Trier</mat-label>
                <mat-select placeholder="Trier" [(ngModel)]="SelectedSortType" (selectionChange)="reorderEventsByFilter()">
                    @for (type of SortTypeList; track type; let i = $index) {
                    <mat-option [value]="type">
                        {{ type }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <div class="p-1" style="max-width: 300px;" mwlDroppable (drop)="externalDrop($event.dropData.event)" dragOverClass="drag-over">
                <div class="card-body">
                    @if (externalEvents.length === 0) {
                    <p>
                        <em>Aucun événement</em>
                    </p>
                    }

                    @for (event of externalEvents; track event) {
                    <div class="border rounded p-1 m-1" style="background: cornflowerblue; color: white;" mwlDraggable [dropData]="{event: event}"
                        [touchStartLongPress]="{ delay: 300, delta: 30 }" dragActiveClass="drag-active">
                        <div class="row justify-content-center">
                            <div class="col text-center clickable" (click)="navigateToDemetra(event.meta.intervention)">
                                {{ event.title }}
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                {{ event.meta.samplingPoint }}
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col text-center">
                                {{ event.meta.clientName }}
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-auto text-center">
                                {{ event.meta.duration }} min
                                @if (event.meta.intervention?.DisponibiliteClient?.From) {
                                <span class="fw-bold">
                                    {{ $safeNavigationMigration(event.meta.intervention?.DisponibiliteClient?.From) | date: 'shortTime'}}-{{
                                    $safeNavigationMigration(event.meta.intervention?.DisponibiliteClient?.To) | date: 'shortTime'}}
                                </span>
                                }
                            </div>
                        </div>
                        <div class="row justify-content-center px-3">
                            @if (event.meta?.intervention.MesuresOPPose) {
                            <div class="col-auto py-0 px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: chartreuse; color: black;">
                                {{event.meta?.intervention.MesuresOPPose}} OP
                            </div>
                            }
                            @if (event.meta?.intervention.MesuresAVTPose || event.meta?.intervention.MesuresAPTPose || event.meta?.intervention.MesuresPDTPose) {
                            <div class="col-auto px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: cadetblue; color: white;">
                                @if (event.meta?.intervention.MesuresAVTPose) {
                                <span>
                                    {{event.meta?.intervention.MesuresAVTPose}} AVT
                                </span>
                                }
                                @if (event.meta?.intervention.MesuresAPTPose) {
                                <span>
                                    {{event.meta?.intervention.MesuresAPTPose}} APT
                                </span>
                                }
                                @if (event.meta?.intervention.MesuresPDTPose) {
                                <span>
                                    {{event.meta?.intervention.MesuresPDTPose}} PDT
                                </span>
                                }
                            </div>
                            }
                            @if (event.meta?.intervention.MesuresAVTDepose || event.meta?.intervention.MesuresPDTDepose || event.meta?.intervention.MesuresAPTDepose) {
                            <div class="col-auto px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: slateblue; color: white;">
                                @if (event.meta?.intervention.MesuresAVTDepose) {
                                <span>
                                    {{event.meta?.intervention.MesuresAVTDepose}} AVT
                                </span>
                                }
                                @if (event.meta?.intervention.MesuresPDTDepose) {
                                <span>
                                    {{event.meta?.intervention.MesuresPDTDepose}} PDT
                                </span>
                                }
                                @if (event.meta?.intervention.MesuresAPTDepose) {
                                <span>
                                    {{event.meta?.intervention.MesuresAPTDepose}} APT
                                </span>
                                }
                            </div>
                            }

                            @if (event.meta?.intervention.MesureLingetteList?.length > 0) {
                            <div class="col-auto py-0 px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: mediumpurple; color: white;">
                                {{event.meta?.intervention.MesureLingetteList?.length}} {{event.meta?.intervention.MesureLingetteList?.length > 1 ? 'Lingettes' : 'Lingette'}}
                            </div>
                            }
                            @if (event.meta?.intervention.MesureMassifList?.length > 0) {
                            <div class="col-auto py-0 px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: tomato; color: white;">
                                {{event.meta?.intervention.MesureMassifList?.length}} {{event.meta?.intervention.MesureMassifList?.length > 1 ? 'Massifs' : 'Massif'}}
                            </div>
                            }
                            @if (event.meta?.intervention.MesureEauList?.length > 0) {
                            <div class="col-auto py-0 px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: aqua; color: black;">
                                {{event.meta?.intervention.MesureEauList?.length}} {{event.meta?.intervention.MesureEauList?.length > 1 ? 'Eaux' : 'Eau'}}
                            </div>
                            }
                            @if (event.meta?.intervention.MesureAdductionAirList?.length > 0) {
                            <div class="col-auto py-0 px-2 mx-1 border rounded-1 fw-bold text-center" style="background-color: darkolivegreen; color: white;">
                                {{event.meta?.intervention.MesureAdductionAirList?.length}} {{event.meta?.intervention.MesureAdductionAirList?.length > 1 ? 'Adductions Air' : 'Adduction Air'}}
                            </div>
                            }
                        </div>
                    </div>
                    }

                </div>
            </div>
        </mat-drawer>

        <div class="h-100">

            <div #calendarHeader>
                <!-- <div class="row" *ngIf="IsDispatch">

      <mat-form-field class="col-12 col-md-3">
        <mat-select placeholder="Agence" [(ngModel)]="SelectedAgency" (selectionChange)="getSamplerOfSelectedAgency()" [compareWith]="compareAgencyWith">
          <mat-option *ngFor="let agency of AgencyList; let i = index" [value]="agency">
            {{ agency.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-12 col-md-3">
        <mat-select placeholder="Technicien" [(ngModel)]="SelectedTechnicianList" multiple (selectionChange)="getSelectedTechnicien($event); closeOpenMonthViewDay(); drawer.open()"
          [compareWith]="compareUserWith">
          <mat-option *ngFor="let tech of TechnicianList; let i = index" [value]="tech" [disabled]="LoadingTask.IsLoading > 0">
            {{ tech.FirstName }} {{ tech.LastName }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
                <!-- <button class="col-auto" color="primary" mat-icon-button (click)="search()">
      <mat-icon class="material-symbols-outlined">search</mat-icon>
    </button> -->

                <!-- </div> -->
                <div class="row " [class.justify-content-center]="!IsDispatch" [class.justify-content-between]="IsDispatch">
                    <!-- <div class="col-auto">
    <mat-button-toggle-group>
      <mat-button-toggle mat-raised-button
        mwlCalendarPreviousView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
        [disabled]="LoadingTask.IsLoading > 0">
        <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle mat-raised-button
        mwlCalendarToday
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
        [disabled]="LoadingTask.IsLoading > 0">
        <mat-icon class="material-symbols-outlined">restore</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle mat-raised-button
        mwlCalendarNextView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
        [disabled]="LoadingTask.IsLoading > 0">
        <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div> -->

                    @if (IsDispatch) {
                    <div class="col-2">
                        <div class="row h-100 align-items-center">
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{PoseAgencyCounters?.pumpWithBattery ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                            </div>
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{PoseAgencyCounters?.pumpWithoutBattery ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined"> power </mat-icon>
                            </div>
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{PoseAgencyCounters?.fan ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined"> wind_power </mat-icon>
                            </div>
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{PoseAgencyCounters?.processMeasure ?? 0}} </span>
                                <mat-icon class="material-symbols-outlined"> vignette </mat-icon>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="col-auto my-auto">
                        <div class="row h-100 align-items-center align-content-center">
                            <button class="col-auto" mat-icon-button mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()"
                                [disabled]="LoadingTask.IsLoading > 0">
                                <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
                            </button>
                            <div class="col">
                                <div class="row align-items-center">

                                    <h3 class="col">{{ viewDate | calendarDate:(view + 'ViewTitle'):'fr' }}</h3>
                                    <button class="col-auto" mat-icon-button (click)="picker.open()">
                                        <mat-icon class="material-symbols-outlined">event</mat-icon>
                                    </button>
                                    <mat-form-field style="width:1px; visibility:hidden; height: 1px;">
                                        <input matInput [matDatepicker]="picker" [(ngModel)]="viewDate" (ngModelChange)="closeOpenMonthViewDay()">
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <!-- <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker> -->
                            </div>
                            <button class="col-auto" mat-icon-button mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()"
                                [disabled]="LoadingTask.IsLoading > 0">
                                <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
                            </button>
                        </div>
                    </div>

                    @if (IsDispatch) {
                    <div class="col-2">
                        <div class="row h-100 align-items-center">
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{DeposeAgencyCounters?.pumpWithBattery ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined" color="accent"> battery_charging_full </mat-icon>
                            </div>
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{DeposeAgencyCounters?.pumpWithoutBattery ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined" color="accent"> power </mat-icon>
                            </div>
                            <div class="col-3 text-center fw-bold">
                                <span style="vertical-align: super">{{DeposeAgencyCounters?.fan ?? 0}}</span>
                                <mat-icon class="material-symbols-outlined" color="accent"> wind_power </mat-icon>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="col-auto text-end">
                        @if (IsDispatch) {
                        <button class="" color="primary" mat-icon-button matTooltip="export du planning" (click)="exportScreen()">
                            <mat-icon class="material-symbols-outlined">checklist</mat-icon>
                        </button>
                        <button class="" color="warn" mat-icon-button matTooltip="prochaine stratégie" (click)="openNextStrategy()">
                            <mat-icon class="material-symbols-outlined">alarm</mat-icon>
                        </button>
                        <button class="" color="primary" mat-icon-button (click)="navigateToUserConfiguration()">
                            <mat-icon class="material-symbols-outlined">settings</mat-icon>
                        </button>
                        <button class="" color="primary" mat-icon-button matTooltip="modifier la hauteur d'un segment horaire" (click)="onSegmentSizeClick()">
                            <mat-icon class="material-symbols-outlined">line_weight</mat-icon>
                        </button>
                        <button class="" color="primary" mat-icon-button matTooltip="cacher les compteurs" (click)="onReduceModeClick()">
                            <mat-icon class="material-symbols-outlined">fit_screen</mat-icon>
                        </button>
                        }
                        @if (IsDispatch || IsValideur) {
                        <button class="" color="primary" mat-icon-button (click)="openAgencyAndTechnicianDialog()">
                            <mat-icon class="material-symbols-outlined">person</mat-icon>
                        </button>
                        }
                        @if (IsDispatch) {
                        <button class="" color="accent" mat-icon-button matTooltip="génération automatique du calendrier" (click)="generateCalendar()"
                            [disabled]="!SelectedTechnicianList || !CanCleanCalendar()">
                            <mat-icon class="material-symbols-outlined">event_repeat</mat-icon>
                        </button>
                        <button class="" color="warn" mat-icon-button matTooltip="vider le calendrier" (click)="cleanCalendar()" [disabled]="!CanCleanCalendar()">
                            <mat-icon class="material-symbols-outlined">event_busy</mat-icon>
                        </button>
                        <button class="" color="primary" mat-icon-button matTooltip="ajouter une pause ou une formation" (click)="openCustomEventBox()"
                            [disabled]="!CanCleanCalendar()">
                            <mat-icon class="material-symbols-outlined">add</mat-icon>
                        </button>
                        <button class="" mat-icon-button (click)="drawer.toggle()" matTooltip="masquer le bandeau de droite" [disabled]="!SelectedAgency">
                            <mat-icon class="material-symbols-outlined">menu_open</mat-icon>
                        </button>
                        }
                    </div>
                </div>
            </div>
            <!-- (eventTimesChanged)="eventTimesChanged($event)" -->
            <div class="row" #toto [style.height]="CalendarHeight">
                <div class="col">
                    <mwl-day-view-scheduler class="" [CalendarHeight]="toto.offsetHeight" [dayStartHour]="6" [dayEndHour]="20" [hourSegments]="SegmentSize" [hourSegmentHeight]="50"
                        [viewDate]="viewDate" [events]="events" [users]="SelectedTechnicianList" (deleteClick)="onDelete($event)" (userChanged)="userChanged($event)"
                        (eventTimesChanged)="eventDropped($event)" (eventClicked)="handleEvent('Clicked', $event.event)" (needRefresh)="closeOpenMonthViewDay()">
                    </mwl-day-view-scheduler>
                </div>
            </div>
        </div>
    </mat-drawer-container>

</div>

<ng-template #customOpenDayEventsTemplate let-events="events" let-isOpen="isOpen" let-eventClicked="eventClicked">

    @if (isOpen) {
    <div class="cal-open-day-events" [@collapse]>
        @for (event of events; track event; let i = $index) {
        <div [ngClass]="$safeNavigationMigration(event?.cssClass)">
            <!-- <h3 *ngIf="i === 0 || !hasSameSamplingPointName(events[i].meta.id, events[i - 1].meta.id)">{{getSamplingPointBySamlingId(event.meta.id)}}</h3> -->
            <span class="cal-event" [style.backgroundColor]="event.color?.primary"></span>
            <mwl-calendar-event-title [event]="event" view="month" (mwlClick)="eventClicked.emit({event: event})">
            </mwl-calendar-event-title>
            <mat-icon class="material-symbols-outlined ms-1" matTooltip="Date/horaire différent de celui initialement mentionné"
                style="color: white;vertical-align: top;">new_releases</mat-icon>
        </div>
        }
    </div>
    }

</ng-template>

<ng-template #customCellTemplate let-day="day" let-openDay="openDay" let-locale="locale" let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay"
    let-unhighlightDay="unhighlightDay" let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody"
    let-tooltipDelay="tooltipDelay" let-trackByEventId="trackByEventId" let-validateDrag="validateDrag">
    <div class="cal-cell-top">
        @if (day.badgeTotal > 0) {
        <mat-icon icon class="material-symbols-outlined mt-3 ms-1 material-icons-outlined" color="primary">emoji_transportation</mat-icon>
        }
        <mat-icon icon class="material-symbols-outlined" matTooltip="Date/horaire différent de celui initialement mentionné">new_releases</mat-icon>
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>

    @if (day.events.length > 0) {
    <div class="cal-events">
        @for (event of day.events; track trackBy($index, event)) {
        <div class="cal-event" [ngStyle]="{ backgroundColor: $safeNavigationMigration(event.color?.primary) }" [ngClass]="$safeNavigationMigration(event?.cssClass)"
            [mwlCalendarTooltip]="event.title | calendarEventTitle: 'monthTooltip':event" [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event"
            [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay" mwlDraggable [class.cal-draggable]="event.draggable"
            dragActiveClass="cal-drag-active" [dropData]="{ event: event, draggedFrom: day }" [dragAxis]="{ x: event.draggable, y: event.draggable }" [validateDrag]="validateDrag"
            [touchStartLongPress]="{ delay: 300, delta: 30 }" (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
            [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'" class="border rounded-circle border-secondary" style="width: 20px; height: 20px; margin-left: 2px;">
        </div>
        }
    </div>
    }
</ng-template>

<ng-template #customDayCellTemplate let-locale="locale" let-dayEvent="dayEvent" let-weekEvent="weekEvent" let-events="events" let-eventClicked="eventClicked"
    let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody">
    @if (events?.length > 0) {
    <div class="cal-events">
        @for (event of events; track event) {
        <div>
            {{event.meta}}
        </div>
        }
    </div>
    }
    <div class="cal-event" [style.borderColor]="weekEvent.event.color?.primary" [style.backgroundColor]="weekEvent.event.color?.secondary"
        [mwlCalendarTooltip]="weekEvent.title | calendarEventTitle:'dayTooltip':weekEvent" (mwlClick)="eventClicked.emit({ event: weekEvent, sourceEvent: $event })">

        <!-- <span class="cal-day-number">{{ viewDate | calendarDate:(view + 'ViewTitle'):'fr' }}
  </span> -->
        <div class="container">
            <div class="row justify-content-center">
                {{weekEvent.event.title}}
            </div>
            <div class="row">
                @for (p of weekEvent.event.meta?.pml; track p) {
                <div class="col-auto">
                    <div class=" fw-bold circle" [style.background]="$any(p).Color" [style.color]="$any(p).TextColor">
                        {{$any(p).MeasureReferenceName}}
                    </div>
                </div>
                }
                @for (z of weekEvent.event.meta?.zml; track z) {
                <div class="col-auto">
                    <div class=" fw-bold circle" [style.background]="$any(z).Color" [style.color]="$any(z).TextColor">
                        {{$any(z).MeasureReferenceName}}
                    </div>
                </div>
                }
            </div>
        </div>

    </div>
    <!-- </div> -->
    <!-- <div class="cal-event"
[style.backgroundColor]="events.event.color?.secondary"
[style.borderColor]="events.event.color?.primary"
[mwlCalendarTooltip]="events.event.title | calendarEventTitle:'dayTooltip':events.event"
(mwlClick)="eventClicked.emit()">
</div> -->
</ng-template>